<template>
    <div class="form-field form-color" :rel="name" v-bind:class="{'form-required': requiredForm, 'form-focus': focus, 'form-disabled':isDisabled}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <label v-for="item in options">
                    <input type="checkbox"
                           v-model="internalValue"
                           :value="item"
                           :disabled="isDisabled"
                           @focus="focus=true"
                           @blur="focus=false"/>
                    <span><span class="color"><i v-bind:style="{background:item.color}"></i></span> {{ item.name }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','multiple', 'default','options','callback','required','disabled'],
        data: function () {
            return {
                internalValue: '',
                focus: false
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.isMultiple = this.multiple == 'true' ? true : false;
            this.onChange = this.callback ? true : false;
            this.isDisabled = this.disabled && (this.disabled == 'true' || this.disabled == true) ? true : false
            this.setDefault(this.default);
        },
        methods: {
            setDefault: function(str){
                if(str){
                    for (let item of this.options) {
                        if( item.id && item.id.toString().toLowerCase() == str.toString().toLowerCase() ){
                            this.internalValue = item;
                        }
                    }
                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'default'(newVal, oldVal) {
                this.setDefault(newVal);
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Color.vue